import Button from 'apollo-react/components/Button';
import IconButton from 'apollo-react/components/IconButton';
import DeleteIcon from 'apollo-react-icons/Trash';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

const ActionCell = ({ row }) => {
  const translateString = useTranslation();
  const { id, isNewRow, imported, onDelete, onOpenExternalDataSource } = row;
  return (
    <>
      <Button
        variant="text"
        size="small"
        disabled={isNewRow || imported}
        onClick={() => onOpenExternalDataSource(row)}
      >
        {translateString('Run')}
      </Button>

      <IconButton style={{ marginLeft: '10px' }} size="small" onClick={() => onDelete(id)}>
        <DeleteIcon />
      </IconButton>
    </>
  );
};

export default ActionCell;
